
import { updateDiagramStepLabels, getDiagramStepLabels } from '@process-advisor/process-miner/processMiner/processMiner';

export type StepLabelsProps = {
    tasks?: boolean;
    avg_duration?: boolean;
    total?: boolean;
}

export const changeStepLabels = ({
    tasks,
    avg_duration,
    total,
}: StepLabelsProps) => updateDiagramStepLabels({
    tasks,
    avg_duration,
    total,
});

export const getStepLabels = (): StepLabelsProps => getDiagramStepLabels();
